
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/open-source-libraries",
      function () {
        return require("private-next-pages/open-source-libraries.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/open-source-libraries"])
      });
    }
  